<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="销售分析" />
    <basicList
      :config="basicListconfig"
      @sortChange="sortChange"
      @search="searchEvent"
    >
      <template v-slot:otherOperations>
        <div class="search_total">
          <el-checkbox
            v-model="is_excl_smoke"
            style="margin-right: 12px"
          >
            非烟草类商品
          </el-checkbox>
        </div>
      </template>
      <template v-slot:additionalFeatures>
        <div class="procurementDataSummary procurementDataSummary2">
          <ul>
            <li>
              <div>
                <div class="summaryTitle">同行占比</div>
                <div class="today summaryLine">
                  <p>{{ summarizeData.thnum }}%</p>
                </div>
              </div>
              <div class="subtotals">
                <p>销量：{{ summarizeData.totalthtotal_num }}</p>
                <p>金额：¥{{ summarizeData.totalthtotal_money | money }}</p>
                <p>毛利：¥{{ summarizeData.totalthdef_money | money }}</p>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">分销占比</div>
                <div class="today summaryLine">
                  <p>{{ summarizeData.fxnum }}%</p>
                </div>
              </div>
              <div class="subtotals">
                <p>销量：{{ summarizeData.totalfxtotal_num }}</p>
                <p>金额：¥{{ summarizeData.totalfxtotal_money | money }}</p>
                <p>毛利：¥{{ summarizeData.totalfxdef_money | money }}</p>
              </div>
            </li>
            <li>
              <!-- <div>
                <div class="summaryTitle">团购</div>
                <div class="yesterday summaryLine">
                  <p>¥{{ summarizeData.totaltgtotal_money | money }}</p>
                </div>
              </div> -->
              <div>
                <div class="summaryTitle">团购占比</div>
                <div class="today summaryLine">
                  <p>{{ summarizeData.tgnum }}%</p>
                </div>
              </div>
              <div class="subtotals">
                <p>销量：{{ summarizeData.totaltgtotal_num }}</p>
                <p>金额：¥{{ summarizeData.totaltgtotal_money | money }}</p>
                <p>毛利：¥{{ summarizeData.totaltgdef_money | money }}</p>
              </div>
            </li>
            <li>
              <!-- <div>
                <div class="summaryTitle">外卖</div>
                <div class="summaryLine">
                  <p>¥{{ summarizeData.totalwmtotal_money | money }}</p>
                </div>
              </div> -->
              <div>
                <div class="summaryTitle">外卖占比</div>
                <div class="today summaryLine">
                  <p>{{ summarizeData.wmnum }}%</p>
                </div>
              </div>
              <div class="subtotals">
                <p>销量：{{ summarizeData.totalwmtotal_num }}</p>
                <p>金额：¥{{ summarizeData.totalwmtotal_money | money }}</p>
                <p>毛利：¥{{ summarizeData.totalwmdef_money | money }}</p>
              </div>
            </li>
            <li>
              <!-- <div>
                <div class="summaryTitle">零售</div>
                <div class="summaryLine">
                  <p>¥{{ summarizeData.totallstotal_money | money }}</p>
                </div>
              </div> -->
              <div>
                <div class="summaryTitle">零售占比</div>
                <div class="today summaryLine">
                  <p>{{ summarizeData.lsnum }}%</p>
                </div>
              </div>
              <div class="subtotals">
                <p>销量：{{ summarizeData.totallstotal_num }}</p>
                <p>金额：¥{{ summarizeData.totallstotal_money | money }}</p>
                <p>毛利：¥{{ summarizeData.totallsdef_money | money }}</p>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">总毛利</div>
                <div class="summaryLine">
                  <p>¥{{ summarizeData.totaldefmoney | money }}</p>
                </div>
              </div>
              <div class="subtotals">
                <p>销售量：{{ summarizeData.totalsalesnum }}</p>
                <p>销售额：¥{{ summarizeData.totalsalesmoney | money }}</p>
              </div>
            </li>
          </ul>
        </div>
        <div style="height: 20px"></div>
      </template>
    </basicList>
  </div>
</template>


<script>
// 列表默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
import { getsalelist } from "@/api/report";
import {
  itemClassGetList,
  getshoplist,
  userGetlist,
} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
export default {
  name: "salesAnalysis",
  data() {
    return {
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operation: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "商品分类",
            type: "treeselect",
            multiple: true,
            options: [],
            key: "class_id",
          },
          {
            label: "销售类型",
            type: "select",
            multiple: true,
            options: [
              {
                label: "同行",
                value: 1,
              },
              {
                label: "分销",
                value: 2,
              },
              {
                label: "团购",
                value: 3,
              },
              {
                label: "外卖",
                value: 4,
              },
              {
                label: "零售",
                value: 5,
              },
            ],
            key: "type_ids",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
          {
            label: "业务员",
            type: "select",
            options: [],
            key: "user_id",
          },
          {
            label: "日期",
            type: "quickDate",
            key: "time",
          },
        ],
        data: [],
        column: [
          {
            label: "品名",
            prop: "name",
            width: 250,
            fixed: "left",
          },
          {
            label: "编号",
            prop: "item_number",
            sortable: true,
            width: 140,
          },
          {
            label: "分类",
            prop: "stock_class_name",
            width: 180,
          },
          {
            label: "门店",
            prop: "shop_name",
            width: 180,
          },
          {
            label: "同行",
            prop: "th_total",
            width: 120,
          },
          {
            label: "分销",
            prop: "fx_total",
            width: 120,
          },
          {
            label: "团购",
            prop: "tg_total",
            width: 120,
          },
          {
            label: "外卖",
            prop: "wm_total",
            width: 120,
          },
          {
            label: "零售",
            prop: "ls_total",
            width: 120,
          },
          {
            label: "销售总量",
            prop: "totalsalesnum",
            // isMoney: true,
            sortable: true,
            width: 150,
          },
          {
            label: "销售成本价",
            prop: "totalavgprice",
            sortable: true,
            isMoney: true,
            width: 150,
          },
          {
            label: "销售总额",
            prop: "totalsalesmoney",
            isMoney: true,
            sortable: true,
            width: 150,
          },
          {
            label: "销售总毛利",
            prop: "totaldefmoney",
            sortable: true,
            isMoney: true,
            width: 150,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },

      // 统计数据
      summarizeData: {
        totalfxtotal_num: 0,
        totalfxtotal_money: 0,
        totalfxdef_money: 0,
        fxnum: 0,
        totaltgtotal_num: 0,
        totaltgtotal_money: 0,
        totaltgdef_money: 0,
        tgnum: 0,
        totalwmtotal_num: 0,
        totalwmtotal_money: 0,
        totalwmdef_money: 0,
        wmnum: 0,
        totallstotal_num: 0,
        totallstotal_money: 0,
        totallsdef_money: 0,
        thnum: 0,
        totalthtotal_num: 0,
        totalthtotal_money: 0,
        totalthdef_money: 0,
        totalsalesnum: 0,
        lsnum: 0,
        totalsalesmoney: 0,
        totaldefmoney: 0,
      },
      is_excl_smoke: false, // 是否显示烟草类商品
    };
  },
  created() {
    this.getData();
    this.obtainDataSource();
    this.searchEvent({
      shop_id: JSON.parse(getRoles()).shop_id,
    });
  },
  methods: {
    // 排序方法
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getData();
    },
    // 搜索方法
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getData();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0 && key == "time") {
              // delete this.basicListconfig.searchParameters.begin_time;
              // delete this.basicListconfig.searchParameters.end_time;
              delete this.basicListconfig.searchParameters["type_id"];
            } else {
              if (key == "type_ids") {
                this.basicListconfig.searchParameters["type_id"] =
                  data[key].join(",");
              } else {
                this.basicListconfig.searchParameters["begin_time"] =
                  data[key][0];
                this.basicListconfig.searchParameters["end_time"] =
                  data[key][1];
              }
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getData();
      }
    },
    getData() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters["shop_id"];
        }
        return item;
      });
      this.basicListconfig.loading = true;
      // 根据 is_excl_smoke
      this.basicListconfig.searchParameters.is_excl_smoke = this.is_excl_smoke
        ? 1
        : 0;
      getsalelist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.total = Number(res.count);
          this.basicListconfig.data = res.list.map((item) => {
            for (const key in item) {
              if (
                key.includes("money") &&
                key != "totalsalesmoney" &&
                key != "totaldefmoney"
              ) {
                item[key] = this.$money(item[key]);
              }
            }
            // 分销
            item.fx_total =
              (item.fx_total_num ? item.fx_total_num : 0) +
              "/" +
              (item.fx_def_money ? item.fx_def_money : 0);
            // 团购
            item.tg_total =
              (item.tg_total_num ? item.tg_total_num : 0) +
              "/" +
              (item.tg_def_money ? item.tg_def_money : 0);

            // 外卖
            item.wm_total =
              (item.wm_total_num ? item.wm_total_num : 0) +
              "/" +
              (item.wm_def_money ? item.wm_def_money : 0);
            // 零售
            item.ls_total =
              (item.ls_total_num ? item.ls_total_num : 0) +
              "/" +
              (item.ls_def_money ? item.ls_def_money : 0);
            // 同行
            item.th_total =
              (item.th_total_num ? item.th_total_num : 0) +
              "/" +
              (item.th_def_money ? item.th_def_money : 0);
            return item;
          });
          for (const key in this.summarizeData) {
            this.summarizeData[key] = res[key] ? res[key] : 0;
          }
          if (parseInt(this.summarizeData.totalsalesmoney) == 0) {
            this.summarizeData.fxnum = 0;
            this.summarizeData.lsnum = 0;
            this.summarizeData.wmnum = 0;
            this.summarizeData.tgnum = 0;
            this.summarizeData.thnum = 0;
          } else {
            this.summarizeData.fxnum = (
              (parseInt(
                this.summarizeData.totalfxtotal_money
                  ? this.summarizeData.totalfxtotal_money
                  : 0
              ) /
                parseInt(this.summarizeData.totalsalesmoney)) *
              100
            ).toFixed(0);

            this.summarizeData.lsnum = (
              (parseInt(
                this.summarizeData.totallstotal_money
                  ? this.summarizeData.totallstotal_money
                  : 0
              ) /
                parseInt(this.summarizeData.totalsalesmoney)) *
              100
            ).toFixed(0);
            this.summarizeData.wmnum = (
              (parseInt(
                this.summarizeData.totalwmtotal_money
                  ? this.summarizeData.totalwmtotal_money
                  : 0
              ) /
                parseInt(this.summarizeData.totalsalesmoney)) *
              100
            ).toFixed(0);
            this.summarizeData.tgnum = (
              (parseInt(
                this.summarizeData.totaltgtotal_money
                  ? this.summarizeData.totaltgtotal_money
                  : 0
              ) /
                parseInt(this.summarizeData.totalsalesmoney)) *
              100
            ).toFixed(0);
            this.summarizeData.thnum = (
              (parseInt(
                this.summarizeData.totalthtotal_money
                  ? this.summarizeData.totalthtotal_money
                  : 0
              ) /
                parseInt(this.summarizeData.totalsalesmoney)) *
              100
            ).toFixed(0);
          }
        } else {
          this.basicListconfig.loading = fals;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取数据源
    obtainDataSource() {
      userGetlist({ limit: 10000, status: 0 }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "user_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            }
            return item;
          });
        } else {
          this.$message.error(res.data.msg || "获取供应商数据源失败！");
        }
      });
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/salesAnalysis/index.vue